import { ApeironCloseButton } from '@apeiron/temp'
import { Box, Dialog, Paper, styled, Typography } from '@mui/material'
import ApeironLoadingButton from '@src/components/share/apeiron/ApeironLoadingButton'
import { FC, ReactChild } from 'react'
import { Trans } from 'react-i18next'

const DialogPaper = styled(Paper)`
  align-items: center;
  background-color: #262829;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 35px;
  justify-content: center;
  max-width: 700px;
  width: 100%;
  ${props => props.theme.breakpoints.up('res1280')} {
    padding: 80px 80px 60px 80px;
  }
  ${props => props.theme.breakpoints.down('res1280')} {
    padding: 60px 20px 40px 20px;
  }
`

const CloseButton = styled(ApeironCloseButton)`
  position: absolute;

  ${props => props.theme.breakpoints.up('res480')} {
    top: 20px;
    right: 20px;
  }
  ${props => props.theme.breakpoints.down('res480')} {
    top: 12px;
    right: 12px;
  }
`

const Text = styled(Typography)`
  font-weight: 400;
  text-align: center;
  white-space: pre-line;
  ${props => props.theme.breakpoints.up('res480')} {
    font-size: 16px;
    line-height: 24px;
  }
  ${props => props.theme.breakpoints.down('res480')} {
    font-size: 14px;
    line-height: 20px;
  }

  strong {
    color: #ffbf36;
  }
`

const ButtonContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  max-width: 400px;
`

const RightButton = styled(ApeironLoadingButton)`
  background: #005bd7;
  border-radius: 4px;
  color: #ffffff;
  text-transform: none;
  white-space: nowrap;
  :hover {
    background: #3682eb;
  }
  :focus {
    background: #1f60b8;
  }
  &.Mui-disabled {
    background: #535556;
    color: #535556;
  }

  ${props => props.theme.breakpoints.up('res480')} {
    font-size: 16px;
    font-weight: 300;
    width: 180px;
    height: 50px;
  }
  ${props => props.theme.breakpoints.down('res480')} {
    width: 130px;
  }
`

const LeftButton = styled(RightButton)`
  background-color: #525355;
  :hover {
    background: #535556;
  }
  :focus {
    background: #535556;
  }
`

const ApeironDialog: FC<Props> = props => {
  const {
    className,
    children,
    leftButton,
    open,
    rightButton,
    onLeftClick,
    onRightClick,
    onClose
  } = props

  return (
    <Dialog
      open={open}
      PaperComponent={DialogPaper}
      onClose={onClose}
      className={className}
    >
      <CloseButton onClick={onClose} />
      <Text className='Custom-Text'>
        <Trans>{children}</Trans>
      </Text>
      <ButtonContainer>
        {leftButton && (
          <LeftButton onClick={onLeftClick}>{leftButton}</LeftButton>
        )}
        {rightButton && (
          <RightButton onClick={onRightClick}>{rightButton}</RightButton>
        )}
      </ButtonContainer>
    </Dialog>
  )
}

type Content = string | undefined | ReactChild

type Props = {
  className?: string
  children?: Array<Content> | Content
  leftButton?: string
  open: boolean
  rightButton?: string
  onLeftClick?: () => void
  onRightClick?: () => void
  onClose?: () => void
}

export default ApeironDialog
